import { render, staticRenderFns } from "./StudentManagemengt.new.vue?vue&type=template&id=6e46a07d&scoped=true"
import script from "./StudentManagemengt.new.vue?vue&type=script&lang=js"
export * from "./StudentManagemengt.new.vue?vue&type=script&lang=js"
import style0 from "./StudentManagemengt.new.vue?vue&type=style&index=0&id=6e46a07d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e46a07d",
  null
  
)

export default component.exports